import { render, staticRenderFns } from "./viewMetadata.vue?vue&type=template&id=fae802d2&scoped=true"
import script from "./viewMetadata.vue?vue&type=script&lang=js"
export * from "./viewMetadata.vue?vue&type=script&lang=js"
import style0 from "./viewMetadata.vue?vue&type=style&index=0&id=fae802d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae802d2",
  null
  
)

export default component.exports